module.exports = __webpack_public_path__ + "static/Corfo-875243337bd9f54ee0342edeee0f6228.png";